import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import Preferences from './../components/Preferences';
import utils from './../lib/utils';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    preferences: state.preferences,
    business: state.business,
    softwares: state.softwares,
    greeting: state.greeting,
    auth:state.auth,
    currentDomain: utils.getCookie('domain'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Preferences);
